import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import type { WageringConfiguration } from '../@types/api';
import { QUERY_KEYS } from '../constants';
import API_ROUTES from '../constants/apiRoutes';
import { getData } from '../utils/api';

export const getWageringConfiguration = async (): Promise<WageringConfiguration | null> => {
  try {
    const configuration = await getData<WageringConfiguration | null>(API_ROUTES.WAGERING_CONFIGS, undefined, 'wallet');

    return configuration ?? null;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) return null;

    throw error;
  }
};

export const useWageringConfiguration = () =>
  useQuery({
    queryKey: [QUERY_KEYS.wageringConfigs],
    queryFn: getWageringConfiguration,
    retry: false,
  });
